/* ActionItemRenderer.js */

"use strict";

class ActionItemRenderer {
    constructor(model, iconElement) {
        this._model = model;
        this._iconElement = iconElement;
        this._rootElem = document.createElement("action-item-gl");
        this._rootElem.component = this._model;
        this._messageElem = document.createElement('p');

        this._registerListeners();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown(){
        let prom = new Promise((resolve)=>{
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            //TODO set all class members to undefined here
            resolve();
        });
        return prom;
    }
    _registerListeners(){
        this._model.on("Shutdown",this._onShutdown = this._onShutdown.bind(this));
        this.model.on('MessageChanged', this._onMessageChanged = this._onMessageChanged.bind(this));
        this._iconElement.addEventListener('click', this._itemClicked = this._itemClicked.bind(this));
        this._messageElem.addEventListener('click', this._itemClicked = this._itemClicked.bind(this));
    }
    _unregisterListeners(){
        this._model.removeListener("Shutdown",this._onShutdown);
        this._iconElement.removeEventListener('click', this._itemClicked);
        this._messageElem.removeEventListener('click', this._itemClicked);
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render(){
        if(!this._rootElem.hasChildNodes()){
            this._rootElem.appendChild(this._iconElement);
            this._messageElem.innerText = this.model.message;
            this._rootElem.appendChild(this._messageElem);
        }
        if (this.model.isDisabled){
            this._rootElem.classList.add('disabled');
            this._iconElement.disabled = true;
        } else {
            this._rootElem.classList.remove('disabled');
            this._iconElement.disabled = false;
        }
        if(this.model.isHidden){
            this._rootElem.classList.add('hidden');
        }else{
            this._rootElem.classList.remove('hidden');
        }
        return Promise.resolve();
    }
    get rootElement(){
        return this.getRootElement();
    }
    getRootElement(){
        return this._rootElem;
    }
    get model(){
        return this.getModel();
    }
    getModel(){
        return this._model;
    }
    _itemClicked() {
        if (!this.model.isDisabled){
            this.model.itemClicked();
        }
    }
    _onMessageChanged(){
        this._messageElem.innerText = this.model.message;
    }
    
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    _onShutdown(){
        this._shutdown();
    }
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/
    //TODO - Nobody should be using methods on a Renderer directly so make all these methods private
    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}
module.exports=ActionItemRenderer;